import { useCustomIndustryAgent } from "../../CustomHooks/useCustomIndustryAgent";
import { SegmentsOverBudgetNotice } from "./SegmentBudgetNotices";
import { StepChecklist } from "./StepChecklist";
import { EstimatedTimeText, RunProgressScrollArea, StepChecklistColumn } from "./styledComponents";
import { translateWithFallback as t } from "./translateWithFallback";

// Figma node 141:5986 — the gradient card that replaces the old subtext + checklist stack. The
// notice + checklist sit in `RunProgressScrollArea` — the panel itself is a fixed height
// (`RunProgressPanel`), so this is what scrolls when a step's detail expansion outgrows it —
// while `EstimatedTimeText` stays a sibling outside that area, pinned to the panel's bottom edge.
export const RunProgressCard = () => {
    const { maxSegments, segmentsOverBudget } = useCustomIndustryAgent();

    return (
        <>
            <RunProgressScrollArea data-automation="market-builder-v2-run-progress-scroll-area">
                {segmentsOverBudget > 0 && (
                    <SegmentsOverBudgetNotice
                        segmentsOverBudget={segmentsOverBudget}
                        maxSegments={maxSegments}
                    />
                )}
                <StepChecklistColumn>
                    <StepChecklist />
                </StepChecklistColumn>
            </RunProgressScrollArea>
            <EstimatedTimeText>
                {t("market.builder.v2.progress.estimatedTime", "Estimated running time: 5 min")}
            </EstimatedTimeText>
        </>
    );
};
